import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ShellComponent, SignedoOutShellComponent } from './shell/shell/shell.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { ResetPasswordComponent } from './login/resetpassword.component';
import { RegisterComponent } from './register/register.component';

import { PricesComponent } from './static/prices';
import { ContactComponent } from './static/contact';
import { TermsComponent } from './static/terms';
import { BulkEmailComponent } from './bulk-email/bulk-email';
const routes: Routes = [

  {
    path: '', component: SignedoOutShellComponent, children: [
      {
        path: '', component: LoginComponent
      },
      {
        path: 'login', component: LoginComponent, pathMatch: 'full'
      },
      {
        path: 'register', component: RegisterComponent
      },
      {
        path: 'terms', component: TermsComponent
      },
      {
        path: 'prices', component: PricesComponent
      },
      {
        path: 'contact', component: ContactComponent
      },
      { path: 'resetpassword/:email/:token', component: ResetPasswordComponent }
    ]
  },
  {
    path: '', component: ShellComponent, children: [
      { path: 'resetpassword/:email/:token', component: ResetPasswordComponent },
      {
        path: 'users',
        loadChildren: './national-user/national-user.module#NationalUserModule'
      },
      {
        path: 'welcome', component: WelcomeComponent
      },
      {
        path: 'bulk-email', component: BulkEmailComponent
      },
      {
        path: 'events',
        loadChildren: './events/events.module#EventsModule'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
